<template>
  <kst-table action input-mode :data="userItemsFinish">
    <b-table-column cell-class="ks-col-nopad" header-class="p-0" width="1">
      <template #header>
        <kst-header-blank />
      </template>
      <template #default="{ row }">
        <kst-tooltip v-if="row.Errors.length > 0" error-mode>
          <template #content>
            <kst-list :items="row.Errors"/>
          </template>
          <kst-icon error-mode/>
        </kst-tooltip>
      </template>
    </b-table-column>

    <b-table-column
      v-slot="{ column, row }"
      field="ItemID"
      :label="StcvItemCatalog.ItemID.ColumnLabel"
    >
      <kst-output box-off field-only
        :field="column.field" :data="row" :catalog="StcvItemCatalog"
      />
    </b-table-column>

    <b-table-column cell-class="ks-col-nopad" header-class="p-0" width="1">
      <template #header>
        <kst-header-blank />
      </template>
      <template #default="{ row }">
        <kst-tooltip info-mode>
          <template #content>
            <kst-list info-mode :items="Model.New.getItemInfoFinish(row)"/>
          </template>
          <kst-icon info-mode/>
        </kst-tooltip>
      </template>
    </b-table-column>

    <b-table-column
      v-slot="{ column, row, index }"
      cell-class="ks-col-packaging"
      field="PackagingName"
      :label="StcvItemCatalog.PackagingName.Label"
    >
      <kst-input error-off field-only
        :field="column.field" :data="row" :catalog="StcvItemCatalog"
        :index="index" :options="row.PackagingOptions"
        @input="handlePackaging(row)" @error="handleRowErrors"
      />
    </b-table-column>

    <b-table-column numeric
      v-slot="{ column, row, index }"
      cell-class="ks-col-qty"
      field="Qty"
      :label="StcvItemCatalog.Qty.Label"
    >
      <kst-input error-off field-only
        :field="column.field" :data="row" :catalog="StcvItemCatalog"
        :index="index" @input="handleQuantity(row)" @error="handleRowErrors"
      />
    </b-table-column>

    <b-table-column numeric
      v-slot="{ column, row }"
      cell-class="ks-col-price"
      field="SellPrice"
      :label="StcvItemCatalog.SellPrice.Label"
    >
      <kst-output box-off field-only
        :field="column.field" :data="row" :catalog="StcvItemCatalog"
      />
    </b-table-column>

    <b-table-column numeric
      v-slot="{ column, row }"
      cell-class="ks-col-subtotal"
      field="SubTotal"
      :label="StcvItemCatalog.SubTotal.Label"
    >
      <kst-output box-off field-only
        :field="column.field" :data="row" :catalog="StcvItemCatalog"
      />
    </b-table-column>

    <template #action="{ index }">
      <kst-tooltip delete-mode hover-only :content="Model.StockConvItem.Module.FullName">
        <kst-button delete-mode is-round @click="handleRowDelete(index)"/>
      </kst-tooltip>
    </template>

    <template #empty-body>
      <ValidationProvider v-slot="{ errors }" name="userItemsFinish" rules="required">
        <kst-error :array-blank-mode="!!errors"/>
      </ValidationProvider>
    </template>
  </kst-table>
</template>

<script>
import DialogMixin from "../../../mixins/DialogMixin.js";
import Info from "../StcvInfo.js";
import Model from "../StcvModel.js";
import StcvItemCatalog from "../StcvItemCatalog.js";

export default {
  mixins: [DialogMixin],
  props: {
    userData: Object,
    userItemsFinish: Array
  },
  data: () => ({
    Model: Model,
    StcvItemCatalog: StcvItemCatalog
  }),
  methods: {
    handlePackaging(item) {
      Model.updateItemByPackaging(item);
      Model.updateItem(item);
      Model.updateDetailsByItemsFinish(this.userData, this.userItemsFinish);
    },
    handleQuantity(item) {
      Model.updateItem(item);
      Model.updateDetailsByItemsFinish(this.userData, this.userItemsFinish);
    },

    handleRowDelete(index) {
      this.showConfirm(
        Info.Message.New_ConfirmDeleteItem,
        this.handleRowDelete_confirm,
        null,
        index
      );
    },
    handleRowDelete_confirm(index) {
      this.userItemsFinish.splice(index, 1);
      Model.updateDetailsByItemsFinish(this.userData, this.userItemsFinish);
    },

    handleRowErrors(errors, field, index) {
      Model.setItemErrors(this.userItemsFinish[index], field, errors);
    }
  }
}
</script>